/**
 * IIFE entry point - exports only the default for clean global assignment
 */
import PaypercutCheckout, { Paypercut } from './index';
import { PaypercutExpressCheckout } from './express';
import { config } from './config';

// Expose the additive clients as top-level globals.
// All globals are bundled in the same script — one CDN tag covers them:
//   window.Paypercut({ ... })                — deferred Elements client
//   window.PaypercutCheckout({ ... })        — standard embedded checkout
//   window.PaypercutExpressCheckout({ ... }) — express checkout (Apple Pay / Google Pay)
if (typeof window !== 'undefined') {
  (window as any).Paypercut = Paypercut;
  (window as any).PaypercutExpressCheckout = PaypercutExpressCheckout;
}

// Log build mode in development
if (config.mode === 'internal') {
  console.warn(`
╔═══════════════════════════════════════════════════════════════╗
║  ⚠️  PAYPERCUT CHECKOUT SDK - INTERNAL BUILD                  ║
╚═══════════════════════════════════════════════════════════════╝

This is an INTERNAL development build with relaxed security settings.

⚠️  DO NOT USE IN PRODUCTION!

This build:
  • Allows localhost origins for development
  • Enables hostedCheckoutUrl override
  • Has verbose logging enabled

For production use, install the latest version:
  npm install @paypercut/checkout-js@latest

Version: ${config.version}
Mode: ${config.mode}
Allowed origins: ${config.allowedOrigins.join(', ')}
  `);
}

export default PaypercutCheckout;
